export function formatPriceRangeForEntity(entity) {
  return formatPriceRange(entity.monthly_price_start, entity.monthly_price_end);
};

export function formatPriceRange(priceStart, priceEnd) {
  return priceStart && priceEnd ? (
    priceStart === priceEnd ?
      `$${Number(priceStart).toLocaleString()}` :
      `$${Number(priceStart).toLocaleString()} - ${Number(priceEnd).toLocaleString()}`
  ) : (
    priceStart ? `$${Number(priceStart).toLocaleString()}+` : (
      priceEnd ? `< $${Number(priceEnd).toLocaleString()}` : 'Please call for pricing'
    )
  );
};

export function formatPhoneNumber(phoneNumber) {
  phoneNumber = phoneNumber.trim();
  if (phoneNumber.length === 7) {
    const matches = phoneNumber.match(/(\d{3})(\d{4})/);
    return `${matches[1]}-${matches[2]}`;
  } else if (phoneNumber.length === 10) {
    const matches = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/);
    return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
  }
  return phoneNumber;
};
